import * as z from "zod"
import { IdentitySystem } from "@prisma/client"

export const ProviderIdentityModel = z.object({
  id: z.number().int(),
  created_at: z.date(),
  updated_at: z.date(),
  provider_id: z.string(),
  system: z.nativeEnum(IdentitySystem),
  value: z.string(),
})
